import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  selectOrderMarketMaker: "selectOrderMarketMaker [Action]",
  selectOrderMarketMakerLoading: "selectOrderMarketMakerLoading [Action]",
  selectOrderMarketMakerAsync: "selectOrderMarketMakerAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const select_order_market_maker_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectOrderMarketMaker:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.selectOrderMarketMakerLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.selectOrderMarketMakerLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "market_maker",
    method_type: "select_order_market_maker",
    data: payload?.data ? payload.data : {},
    size: payload?.size ?? 10,
    from: payload?.from ?? 0,
    sort_by: payload?.sort_by ?? undefined,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.selectOrderMarketMaker,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.selectOrderMarketMakerLoading,
      payload: false,
    });
  }
}

export function* selectOrderMarketMaker() {
  yield takeLatest(actionTypes.selectOrderMarketMakerAsync, handleWorker);
}
